import { create } from 'zustand';

import { IParamsUpdateActivities } from '@/api/repository/activities.d';

export type Violation = IParamsUpdateActivities;

interface ReportState {
  violations: Violation[];
  addViolation: (violation: Violation) => void;
  removeViolation: (id: string) => void;
  clearViolations: () => void;
}

export const useReportStore = create<ReportState>((set) => ({
  violations: [],
  addViolation: (violation: Violation) =>
    set((state) => ({
      violations: [...state.violations, violation],
    })),
  removeViolation: (id: string) =>
    set((state) => ({
      violations: state.violations.filter(
        (violation) => violation.sessionId !== id
      ),
    })),
  clearViolations: () => set({ violations: [] }),
}));
